import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { Pagination, PaginationItem } from "@mui/material";
import {
  useCallHistoryQuery,
  useEditAgentMappingUsersQuery,
  useAgentListQuery
} from "../../Services/Telephony/Telephony";
import LoadingSpinner from "../../components/LoadingSpinner";
import EmptyRows from "../../components/reusableComponent/EmptyRows";
import { formatDate } from "../../components/reusableComponent/DateFormat";
import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";
import { useNavigate } from "react-router-dom";

const Index = () => {
  // DON"T REMOVE BELOW COMMENTED CODE
  const userRole = localStorage.getItem("user_role");
  const getUserId = localStorage.getItem("User_Id");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Initialize with the current date in YYYY-MM-DD format
  const [loading, setLoading] = useState<boolean>(false);
  const [agentUsersData, setAgentUsersData] = useState([]);
  const [usersLoader, setUsersLoader] = useState(false);

  const formatDate1 = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  // Initialize current date (dateTo)
  const currentDate = new Date();
  const formattedCurrentDate = formatDate1(currentDate);

  // Calculate dateFrom (6 days prior)
  const dateFromValue = new Date();
  dateFromValue.setDate(currentDate.getDate() - 6);
  const formattedDateFrom = formatDate1(dateFromValue);

  const [dateFrom, setDateFrom] = useState<string>(formattedCurrentDate);
  const [dateTo, setDateTo] = useState<string>(formattedCurrentDate);
  const [selectProcess, setSeectProcess] = useState<any>("All");
  const [agentId, setAgentId] = useState<any>("all");
  const [params, setParams] = useState<any>({ gte: dateFrom, lte: dateTo });
  const { data, refetch, isLoading, status } = useCallHistoryQuery(params, {
    skip: !params,
  });
  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [10, 25, 50, 100];

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when page size changes
  };

  const {
    data: usersData,
    status: agentMappingUserStatus,
    refetch: refetchUserData,
  } = useAgentListQuery({}, { skip: userRole === "agent" });

  // Sample Data

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setCurrentPage(newPage);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (userRole === "agent") {
      setAgentId(getUserId);
    }
  }, [getUserId, userRole]);

  useEffect(() => {
    if (agentMappingUserStatus === "pending") {
      setUsersLoader(true);
    } else {
      setUsersLoader(false);
    }
  }, [agentMappingUserStatus]);

  useEffect(() => {
    if (usersData) {
      setAgentUsersData(usersData);
    }
  }, [usersData, refetchUserData]);

  const handleDateFromChange = (event: any) => {
    setDateFrom(event.target.value);
  };

  const handleDateToChange = (event: any) => {
    setDateTo(event.target.value);
  };
  // useEffect(() => {
  //   const queryParams = {
  //     gte: dateFrom,
  //     lte: dateTo,
  //     page: currentPage,
  //     page_size: 10,
  //   };

  //   if (selectProcess !== "All") {
  //     queryParams["call_type"] = selectProcess;
  //   }
  //   if (agentId !== "all") {
  //     queryParams["user_id"] = agentId;
  //   }

  //   setParams(queryParams);
  // }, [dateFrom, dateTo, selectProcess, currentPage, agentId]);
  useEffect(() => {
    const queryParams: any = {
      gte: dateFrom,
      lte: dateTo,
      page: currentPage,
      page_size: pageSize,
    };
    if (selectProcess !== "All") queryParams.call_type = selectProcess;
    if (agentId !== "all") queryParams.user_id = agentId;
    setParams(queryParams);
  }, [dateFrom, dateTo, selectProcess, currentPage, agentId, pageSize]);

  useEffect(() => {
    if (data?.count) {
      setTotalPages(Math.ceil(data?.count / 10));
    }
  }, [data]);
  useEffect(() => {
    // Reset currentPage to 1 whenever dateFrom, dateTo, or selectProcess changes
    setCurrentPage(1);
  }, [dateFrom, dateTo, selectProcess]);

  useEffect(() => {
    if (status === "pending") {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [status]);

  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
      },
    },
  };

  const handleChange = (e) => {
    setSeectProcess(e.target.value);
  };
  useEffect(() => {
    if (data?.count) {
      setTotalPages(Math.ceil(data.count / pageSize));
    }
  }, [data, pageSize]);

  const agentSelectHandler = (e) => {
    setAgentId(e.target.value);
    setCurrentPage(1);
  };
  const handleBackButtonClick = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div className="custom-style">
      <div id="kt_app_content_container" className="app-container mx-5">
        <div className="card card-flush">
          <div className="card-header align-items-center py-1 gap-2">
            <h2 className="p-4" style={{ marginLeft: "-13px" }}>
              <button className="btn btn-link" onClick={handleBackButtonClick}>
                <i
                  className="bi bi-arrow-90deg-left"
                  style={{
                    fontSize: "20px",
                    color: "black",
                    cursor: "pointer",
                    marginRight: "7px",
                  }}
                ></i>
              </button>
              Call history
            </h2>
          </div>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {/* Filter */}
            <div
              style={{
                marginLeft: "25px",
                width: "60%",
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              {/* From Date */}

              <div className="w-100 mw-150px">
                <TextField
                  id="date-from"
                  label="From"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: {
                      max: new Date().toISOString().split("T")[0], // Restrict to today or earlier
                      style: {
                        textTransform: "uppercase",
                      }, // Optional: uppercase input text
                    },
                  }}
                  fullWidth
                  value={dateFrom}
                  onChange={handleDateFromChange}
                />
              </div>

              <div className="w-100 mw-150px">
                <TextField
                  id="date-to"
                  label="To"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: {
                      max: new Date().toISOString().split("T")[0], // Restrict to today or earlier
                      style: {
                        textTransform: "uppercase",
                      }, // Optional: uppercase input text
                    },
                  }}
                  fullWidth
                  value={dateTo}
                  onChange={handleDateToChange}
                />
              </div>

              {/* To Date */}

              {/* Dropdown */}
              <div
                className="w-150 mw-150px"
                style={{
                  flex: "1 1 200px",
                  marginRight: "10px",
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="Assignee-select-label">
                    Select process
                  </InputLabel>
                  <Select
                    labelId="Assignee-select-label"
                    id="Assignee-select"
                    label="Select process"
                    MenuProps={MenuProps}
                    value={selectProcess}
                    onChange={handleChange}
                  >
                    <MenuItem key="all" value="All">
                      All
                    </MenuItem>

                    <MenuItem value={"inbound"}>Inbound</MenuItem>
                    <MenuItem value={"outbound"}>Outbound</MenuItem>
                  </Select>
                </FormControl>
              </div>

              {/* Uncomment this after the approval */}
              {userRole != "agent" && (
                <div
                  className="w-150 mw-150px"
                  style={{
                    flex: "1 1 200px",
                    marginRight: "10px",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="Assignee-select-label">
                      Select agent
                    </InputLabel>
                    <Select
                      labelId="Assignee-select-label"
                      id="Assignee-select"
                      label="Select process"
                      MenuProps={MenuProps}
                      value={agentId}
                      onChange={agentSelectHandler}
                    >
                      <MenuItem value="" disabled>
                        {usersLoader ? (
                          <>
                            Searching... <CircularProgress size={20} />
                          </>
                        ) : (
                          "Select User"
                        )}
                      </MenuItem>
                      <MenuItem key="all" value="all">
                        All
                      </MenuItem>

                      {!usersLoader &&
                        agentUsersData.map((user, index) => (
                          <MenuItem key={index} value={user.id}>
                            {user.username}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
              )}
            </div>
          </div>

          <div className="row gap-5 ms-3" style={{ marginTop: "20px" }}>
            <div className="row">
              <div className="col">
                <div
                  className="card mb-n5 my-1 p-4"
                  style={{ backgroundColor: "#E4E4E47F" }}
                >
                  <div className="row align-items-center">
                    <div className="col text-start">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">Sr.No</strong>
                      </label>
                    </div>
                    {/* Customer Name */}
                    <div className="col text-start">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">Customer name</strong>
                      </label>
                    </div>

                    {/* Campaign Name */}
                    <div className="col text-center">
                      <label htmlFor="">
                        <strong className="d-flex gap-2"> {selectProcess === "inbound"
                          ? "Queue name"
                          : "Campaign name"}

                        </strong>
                      </label>
                    </div>

                    {/* Start Time */}
                    <div className="col text-center">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">Start time</strong>
                      </label>
                    </div>

                    {/* End Time */}
                    <div className="col text-center">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">End time</strong>
                      </label>
                    </div>

                    {/* Mobile No */}
                    <div className="col text-center">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">Mobile no</strong>
                      </label>
                    </div>

                    {/* Duration */}
                    <div className="col text-center">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">Duration</strong>
                      </label>
                    </div>

                    {/* Disposition */}
                    <div className="col text-center">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">Disposition</strong>
                      </label>
                    </div>

                    {/* Disposition */}
                    <div className="col text-center">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">Remarks</strong>
                      </label>
                    </div>
                    {userRole != "agent" && (
                      <div className="col text-center">
                        <label htmlFor="">
                          <strong className="d-flex gap-2">Agent name</strong>
                        </label>
                      </div>
                    )}

                    {/* Process */}
                    <div className="col text-center">
                      <label htmlFor="">
                        <strong className="d-flex gap-2">Process</strong>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                {loading ? (
                  <LoadingSpinner />
                ) : (
                  <div>
                    {data?.results?.length > 0 ? (
                      <>
                        {data?.results?.map((user, index) => (
                          <div className="card mt-2 my-1 p-4" key={index}>
                            <div className="row align-items-start">
                              <div className="col text-start">
                                <label>
                                  {(currentPage - 1) * pageSize + index + 1}
                                </label>
                              </div>
                              {/* Customer Name */}
                              <div className="col text-start">
                                <label>{user?.contacts[0]?.name || ""}</label>
                              </div>

                              {/* Campaign Name */}
                              <div className="col text-center">
                                <label>{user.campaign_name || ""}</label>
                              </div>

                              {/* Start Time */}
                              <div className="col text-center">
                                <label>
                                  {user && user.call_start_time_display
                                    ? formatDate(user.call_start_time_display)
                                    : ""}
                                </label>
                              </div>

                              {/* End Time */}
                              <div className="col text-center">
                                <label>
                                  {user && user.call_end_time_display
                                    ? formatDate(user.call_end_time_display)
                                    : ""}
                                </label>
                              </div>

                              {/* Mobile No */}
                              <div className="col text-center">
                                <label>{user.customer_phone_no || ""}</label>
                              </div>

                              {/* Duration */}
                              <div className="col text-center">
                                <label>
                                  {user.conversation_duration || ""}
                                </label>
                              </div>

                              {/* Disposition */}
                              <div className="col text-center">
                                <label>
                                  {capitalizeFirstLetter(user.dispose_remark) ||
                                    ""}
                                </label>
                              </div>
                              <div className="col text-center">
                                <div
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    // maxWidth: "150px",
                                    // maxHeight: "60px",
                                    // overflowY: "auto",
                                  }}
                                >
                                  {capitalizeFirstLetter(user.remarks) || "-"}
                                </div>
                              </div>

                              {userRole != "agent" && (
                                <div className="col text-center">
                                  <label>
                                    {capitalizeFirstLetter(user.agent_name) ||
                                      ""}
                                  </label>
                                </div>
                              )}

                              {/* Process */}
                              {/* <div className="col text-center">
                                <label
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title={
                                    user?.call_type === "outbound"
                                      ? "Outbound"
                                      : user?.call_type === "inbound"
                                      ? "Inbound"
                                      : ""
                                  }
                                >
                                  {user?.call_type === "outbound" ? (
                                    <i
                                      className="bi bi-telephone-outbound"
                                      style={{ fontSize: "20px" }}
                                    ></i>
                                  ) : (
                                    <i
                                      className="bi bi-telephone-inbound"
                                      style={{ fontSize: "20px" }}
                                    ></i>
                                  )}
                                </label>
                              </div> */}
                              <div className="col text-center">
                                <label
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title={
                                    user?.call_type === "outbound"
                                      ? "Outbound"
                                      : user?.call_type === "inbound"
                                        ? "Inbound"
                                        : ""
                                  }
                                >
                                  {user?.recording_link ? (
                                    <a
                                      href={user.recording_link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "inherit", textDecoration: "none" }}
                                    >
                                      <i
                                        className={`bi ${user.call_type === "outbound"
                                            ? "bi-telephone-outbound"
                                            : "bi-telephone-inbound"
                                          }`}
                                        style={{ fontSize: "20px", cursor: "pointer" }}
                                      ></i>
                                    </a>
                                  ) : (
                                    <i
                                      className={`bi ${user.call_type === "outbound"
                                          ? "bi-telephone-outbound"
                                          : "bi-telephone-inbound"
                                        }`}
                                      style={{ fontSize: "20px" }}
                                    // title="No recording available"
                                    ></i>
                                  )}
                                </label>
                              </div>

                            </div>
                          </div>
                        ))}
                      </>
                    ) : (
                      <EmptyRows value={""} />
                    )}
                  </div>
                )}
              </div>
            </div>

            {data?.results?.length > 0 && (
              <>
                <div
                  className="d-flex justify-content-between align-items-center mt-4 px-2"
                  style={{ marginBottom: "8px" }}
                >
                  {/* Left: Rows per page */}
                  <div className="d-flex align-items-center gap-4">
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                        Show
                      </span>
                      <select
                        className="form-select form-select-sm"
                        style={{
                          width: "60px",
                          fontSize: "14px",
                          padding: "2px 6px",
                        }}
                        name="perpage"
                        value={pageSize}
                        onChange={handlePageSizeChange}
                      >
                        {pageSizeOptions.map((size) => (
                          <option key={size} value={size}>
                            {size}
                          </option>
                        ))}
                      </select>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#495057",
                        }}
                      >
                        per page
                      </span>
                    </div>
                  </div>

                  {/* Right: Pagination */}
                  <div
                    className="d-flex align-items-center"
                    style={{ paddingRight: "8px" }}
                  >
                    <Pagination
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                        "& .MuiPaginationItem-root": {
                          fontSize: "14px",
                          minWidth: "36px",
                          height: "36px",
                          margin: "0 2px",
                          borderRadius: "6px",
                          border: "1px solid #e5e7eb",
                          color: "#374151",
                          "&:hover": {
                            backgroundColor: "#f9fafb",
                            borderColor: "#d1d5db",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#6366f1",
                            color: "#ffffff",
                            borderColor: "#6366f1",
                            "&:hover": {
                              backgroundColor: "#4f46e5",
                              borderColor: "#4f46e5",
                            },
                          },
                        },
                      }}
                      count={totalPages}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      showFirstButton
                      showLastButton
                      renderItem={(item) => {
                        if (item.type === "page") {
                          const isNearCurrent =
                            Math.abs(item.page - currentPage) <= 1 ||
                            item.page === 1 ||
                            item.page === totalPages;
                          return isNearCurrent ? (
                            <PaginationItem {...item} />
                          ) : null;
                        }
                        return <PaginationItem {...item} />;
                      }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
